export default "__VITE_ASSET__pbc7GUbG__"